import * as Yup from 'yup';
import {IAdminInfo} from '@/utils/types/superAdmin.interface';
import {emailSchema} from '@/utils/validation';

export interface IProfileGeneralForm {
	admin: IAdminInfo | null;
}

export interface AdminProfileValues {
	name: string;
	email: string;
}

export const defaultInitialValues: AdminProfileValues = {
	name: '',
	email: '',
};

export const validationSchema = () => {
	return Yup.object().shape({
		name: Yup.string().required('Admin name is required').trim(),
		email: emailSchema,
	});
};
